export default {
  '测试记录列表':'測試記錄列表',
  '日期':'日期',
  '请输入名称/发布人模糊搜索':'請輸入名稱/發佈人模糊搜尋',
  '视频不存在':'視頻不存在',
  '运动时长':'運動時長',
  '锻炼时间':'鍛鍊時間',
  '测试记录':'測試記錄',
  '姓名、学籍号模糊搜索':'姓名、學籍號模糊搜索',
  '用户列表':'用戶列表',
  '未开始':'未開始',
  '进行中':'進行中',
  '已结束':'已結束',
  '关键字':'關鍵字',
  '请输入名称关键字':'請輸入名稱關鍵字',
  '秒':'秒',

  //4.17
  '时间':'時間',
  '组别':'組別',
  '第':'第',
  '组':'組',
  '请输入组名ID成员模糊搜索':'請輸入組名/ID/成員模糊搜索',
  '随堂赛记录':'隨堂賽記錄',
  '组名':'組名',
  '组ID':'組ID',
  '成员':'成員',
  '总成绩':'總成績',
  '平均成绩':'平均成績',
  '小时':'小時',
  '分':'分',
  '完成时间':'完成時間',

}